import * as React from 'react';

const SvgNavVersionsFill = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M4 6h16v2H4zM5 2h14v2H5zM3 10h18v12H3z" })
);

export { SvgNavVersionsFill as default };
//# sourceMappingURL=NavVersionsFill.es.js.map
